import { render, staticRenderFns } from "./ClassePage.vue?vue&type=template&id=35466def&"
import script from "./ClassePage.vue?vue&type=script&lang=js&"
export * from "./ClassePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports